import React, { useLayoutEffect } from "react";
import { TouchableOpacity, Image, SafeAreaView, View } from "react-native";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import { useNavigation, DrawerActions } from "@react-navigation/native";
// Screens
import HomeScreen from "../screens/HomeScreen";
import RewardsScreen from "../screens/RewardsScreen";
import StatsScreen from "../screens/StatsScreen";
// icons
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";
import {
	AntDesign,
	FontAwesome,
	FontAwesome5,
	MaterialIcons,
} from "@expo/vector-icons";
import { AvatarImage } from "../assets";
import Chronology from "../screens/ChronologyScreen";

const TabStack = createBottomTabNavigator();

const CustomHeaderLeft = () => {
	const navigation = useNavigation();
	return (
		<TouchableOpacity
			className=""
			onPress={() => {
				navigation.dispatch(DrawerActions.openDrawer());
			}}
		>
			<AntDesign name="menuunfold" size={24} color="white" />
		</TouchableOpacity>
	);
};

const CustomHeaderRight = () => {
	const navigation = useNavigation();
	return (
		<View className="w-6 h-6"></View>
		// <TouchableOpacity onPress={() => {}}>
		// 	<FontAwesome name="user-circle-o" size={24} color="white" />
		// </TouchableOpacity>
	);
};

const TabStackNavigator = () => {
	const navigation = useNavigation();
	useLayoutEffect(() => {
		navigation.setOptions({
			headerShown: false,
			headerShadowVisible: false,
		});
	}, []);

	return (
		<TabStack.Navigator
			backBehavior="history"
			screenOptions={{
				headerShown: true,
				headerLeft: CustomHeaderLeft,
				headerLeftContainerStyle: {
					paddingLeft: 16,
					justifyContent: "center",
				},
				headerRight: CustomHeaderRight,
				headerRightContainerStyle: {
					paddingRight: 16,
					justifyContent: "center",
				},
				headerTitleContainerStyle: {
					alignItems: "center",
					justifyContent: "center",
				},
				tabBarActiveTintColor: "white",
				tabBarInactiveTintColor: "#555555",
				tabBarStyle: {
					backgroundColor: "#1E272C",
					borderTopColor: "#1E272C",
				},
			}}
		>
			<TabStack.Screen
				name="mateMATTIci"
				component={HomeScreen}
				options={{
					tabBarLabel: "Home",
					title: "mateMATTIci",
					// headerShown: true,
					tabBarIcon: ({ color }) => (
						<MaterialCommunityIcons
							name="home"
							color={color}
							size={26}
						/>
					),
				}}
			/>
			<TabStack.Screen
				name="Statistiche account"
				component={StatsScreen}
				options={{
					tabBarLabel: "Statistiche",
					tabBarIcon: ({ color }) => (
						<MaterialCommunityIcons
							name="chart-line"
							color={color}
							size={26}
						/>
					),
				}}
			/>
			<TabStack.Screen
				name="Cronologia"
				component={Chronology}
				options={{
					tabBarLabel: "Cronologia",
					tabBarIcon: ({ color }) => (
						<MaterialIcons name="history" size={26} color={color} />
					),
				}}
			/>
			{/* <TabStack.Screen
				name="Premi e livello"
				component={RewardsScreen}
				options={{
					tabBarLabel: "Trofei",
					tabBarIcon: ({ color }) => (
						<MaterialCommunityIcons
							name="trophy"
							color={color}
							size={26}
						/>
					),
				}}
			/> */}
		</TabStack.Navigator>
	);
};

export default TabStackNavigator;
